import Bus from './bus'

window.Kvass.migrate(Bus)
export default Bus
